import React, { useState } from 'react';
import PrimaryModal from '../../UI/Modal/PrimaryModal';
import { ErrorButton, PrimaryButton } from "../../UI";
import { useUserContext } from '../../../contexts/UserContext';
import { updateSpecificAdobeIoProduct } from '../../../utils/APIs';
import { useContentfulContext } from '../../../contexts/ContentfulContext';

const DeactivateIntegrationModal = ({ setDeactivateIntegration, id, setActionLoading, setConfirmModal, getAdobeData }) => {
    const { userData } = useUserContext();
    const { content } = useContentfulContext();

    const [error,setErrors]=useState({
        active:'',
        deactivate:'',
        delete:''
    })
    const handleUpdateProduct = async(id)=>{
        try {
            setActionLoading(true);
            const bodyData = { state: "Inactive" };
            const result = await updateSpecificAdobeIoProduct(
                userData.token,
                userData.selectedOrganization.org_token,
                { productId: id, bodyData }
            );
            if (result) {
                setDeactivateIntegration(false);
                setConfirmModal({
                    active: false,
                    deactivate: true,
                    delete: false
                });
                setActionLoading(false);
                await getAdobeData()
            }
        } catch (error) {
            setErrors({ active: '', deactivate: error?.message, delete: '' });
            setActionLoading(false);
        }
    }

    return (
        <>
             <PrimaryModal title={content.DEACTIVATE_INTEGRATION_MODAL.title} hideModal={setDeactivateIntegration}>
                <div className='p-6 space-y-6'>
                 <p className="text-base leading-tight tracking-tight text-black mb-4">{content.DEACTIVATE_INTEGRATION_MODAL.description_1}</p>
                 <p className="text-base leading-tight tracking-tight text-red-500 mb-4">{error.deactivate}</p>

                    <div className="mb-4 space-x-4">
                        <ErrorButton handleClick={() => {
                            handleUpdateProduct(id)
                        }}>{content.DEACTIVATE_INTEGRATION_MODAL.formLabels.deactivate_integration_cta}</ErrorButton>
                        <PrimaryButton handleClick={() => {
                            setDeactivateIntegration(false);
                        }}>{content.DEACTIVATE_INTEGRATION_MODAL.formLabels.cancel_cta}</PrimaryButton>
                    </div>
                </div>
            </PrimaryModal> 
        </>
    )
}

export default DeactivateIntegrationModal;